import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { Kpi } from "../../../types";
import { kpiService } from "../../../services/kpiService";

export const useUpdateKpi = () => {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: async ({
      kpiId,
      kpi,
    }: {
      kpiId: string;
      kpi: Partial<Pick<Kpi, "name" | "description" | "thresholds">>;
    }) => {
      const updated = await kpiService.patch(kpiId, kpi);
      return { updated, kpiId };
    },
    onSuccess: ({ updated, kpiId }) => {
      qc.setQueryData(["kpi", updated.id], updated);
      qc.invalidateQueries({ queryKey: ["kpi", kpiId] });
      qc.invalidateQueries({ queryKey: ["kpis"] });
      qc.invalidateQueries({ queryKey: ["service-templates"] });
    },
  });
};
